import { useEffect, useRef } from 'react';
import './Modal.css';
import { ReactComponent as Close } from 'assets/svg/close.svg';

const Modal = (props) => {
  const { title, closeHandler, text, children, modalContentClassname, disableOutsideClick } = props;
  const modalRef = useRef(null);

  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('pr-[6px]');
    return () => {
      document.body.classList.remove('pr-[6px]');
      document.body.classList.remove('overflow-hidden');
    };
  }, []);

  return (
    <div
      id='modal'
      className='modal-overlay -z-10'
      onClick={(e) => {
        // Close only if clicking directly on the overlay and outside click is not disabled
        if (e.target.id === 'modal' && !disableOutsideClick) {
          closeHandler && closeHandler();
        }
      }}
    > 
      <div
        id='modal-content'
        className={
          `bg-white lg:p-8 md:p-6 p-4 rounded-lg shadow-lg max-w-sm w-full  ` +
          modalContentClassname
        }
        ref={modalRef}
        onClick={(e) => e.stopPropagation()} // <-- THIS IS KEY
      >
        <div className='overflow-y-auto max-h-[90vh] overflow-x-auto'>
          <div className='flex items-center'>
            <h2 className='leading-[0.8] mt-4 text-red-black font-[700] xl:text-[40px] md:text-[40px] sm:text-[30px] text-[25px] '>
              {title}
            </h2>
            <Close
              onClick={() => {
                closeHandler && closeHandler();
              }}
              className='ml-auto cursor-pointer md:!w-5 md:!h-5 w-4 h-4'
            />
          </div>

          {text && (
            <p
              dangerouslySetInnerHTML={{ __html: text }}
              className='font-[400] mb-6 leading-[1.5] text-gray-3 my-4 xl:text-[20px] md:text-[18px] sm:text-[18px] xs:text-[16px]'
            ></p>
          )}
          <>{children}</>
        </div>
      </div>
    </div>
  );
};

export default Modal;
